import { useEffect, useContext, ReactNode } from 'react';
import { useRouter } from 'next/router';
import toast from 'react-hot-toast';
import useUser from './useUser';
import { AppNameContext } from 'ui';
import { TenantEnum } from 'contactabilidad-common';

const tenantRoleMap: Record<string, string> = {
  [TenantEnum.gdc]: 'access_gdc',
  [TenantEnum.gdg]: 'access_gdg',
  [TenantEnum.efg]: 'access_efg',
};

interface TenantGuardProps {
  children: ReactNode;
}

export const TenantGuard = ({ children }: TenantGuardProps) => {
  const user = useUser();
  const router = useRouter();
  const appName = useContext(AppNameContext);

  useEffect(() => {
    if (!router.isReady || user === undefined) {
      return;
    }

    const pathPrefix = router.asPath.split('/')[1];

    if (!pathPrefix) {
      return;
    }

    if (!Object.values(TenantEnum).includes(pathPrefix as TenantEnum)) {
      router.replace('/');
      return;
    }

    if (pathPrefix && tenantRoleMap[pathPrefix as keyof typeof tenantRoleMap]) {
      const requiredRole =
        tenantRoleMap[pathPrefix as keyof typeof tenantRoleMap];
      const hasPermission = user?.roles?.includes(`${appName}/${requiredRole}`);

      if (!hasPermission) {
        // show error message or toast here if you want
        toast.error('No tienes permiso para acceder a esta sección.');
        router.replace('/');
      }
    }
  }, [user, router.asPath, router.isReady, appName, router]);

  return <>{children}</>;
};
